import { Component, inject, OnInit } from '@angular/core';
import { DxLoadPanelComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import * as sha512 from 'js-sha512';
import { Pwd } from 'src/app/models/pwd';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { UtentiService } from 'src/app/shared/services/utenti.service';
import { AggiornaPasswordModel } from 'src/app/shared/utils/ildato-gestione-password/aggiorna-password-model';
import { IlDatoAggiornaPasswordComponent } from 'src/app/shared/utils/ildato-gestione-password/ildato-aggiorna-password/ildato-aggiorna-password.component';
import { ParametriPasswords } from 'src/app/shared/utils/ildato-gestione-password/parametri-passwords';

@Component({
  selector: 'app-cambio-password-new',
  templateUrl: './cambio-password-new.component.html',
  styleUrls: ['./cambio-password-new.component.scss'],
  imports: [DxLoadPanelComponent, IlDatoAggiornaPasswordComponent],
  standalone: true,
})
export class CambioPasswordNewComponent implements OnInit {
  private utentiS = inject(UtentiService);
  private nS = inject(NavigatorService);
  private storageService = inject(StorageService);
  private paramService = inject(ParametriService);
  //vecchiaPwd: string;
  //nuovaPwd: string;
  //password = "";
  //passwordPattern: any = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  //passwordPattern: any = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.,_+=#*$!%*?&])[A-Za-z\d@.,_+=#*$!%*?&]{8,}$/;

  username: string;
  parametriPasswords: ParametriPasswords;
  loadPanelVisible = false;

  constructor() {
    this.username = this.storageService.utenteCorrente.username;
  }

  ngOnInit() {
    this.loadPanelVisible = true;
    this.paramService.getParametriPasswords().subscribe({
      next: (res) => {
        this.loadPanelVisible = false;
        this.parametriPasswords = res;
      },
      error: (error) => {
        this.loadPanelVisible = false;
        if (error?.error?.title) {
          notify(error?.error?.title, 'error');
        } else {
          notify('Errore caricamento parametri password', 'error');
        }
      },
    });
  }

  onIlDatoAggiornaPasswordEvent(passwordData: AggiornaPasswordModel) {
    this.loadPanelVisible = true;
    const vecchiaPwd512 = sha512.sha512(passwordData.password);
    const nuovaPwd512 = sha512.sha512(passwordData.newPassword);
    const pwd = new Pwd();
    pwd.OldPwd = vecchiaPwd512;
    pwd.NewPwd = nuovaPwd512;
    this.utentiS.cambioPassword(pwd).subscribe({
      next: (result) => {
        this.loadPanelVisible = false;
        console.debug('Esito cambio password:' + result);
        notify({
          message: 'Cambio password eseguito con successo',
          width: 450,
          shading: true,
          type: 'success',
        });
        this.nS.goToHome();
      },
      error: (error) => {
        this.loadPanelVisible = false;
        console.error('Errore cambio password: ' + error);
        if (error?.error?.title) {
          notify(error?.error?.title, 'error', 5000);
        } else {
          notify('Utente non trovato o password non valida', 'warning', 5000);
        }
      },
    });
  }
}
